import React, { useState, useEffect } from 'react';

// Custom hook for responsive detection
export const useIsDesktop = (breakpoint = 840) => {
    const [isDesktop, setIsDesktop] = useState(false);
  
    useEffect(() => {
      const handleResize = () => setIsDesktop(window.innerWidth >= breakpoint);
  
      handleResize(); // Initialize on mount
      window.addEventListener('resize', handleResize);
  
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);
  
    return isDesktop;
  };